import React, { useContext, useEffect } from 'react';
import { Walkthrough, withLocalization } from '@adac-mp/components';
import { IOfferContext, OfferContext, countryUrlMap, getUrlBasePath, setRouteLangParam } from '@adac-mp/shared';

import VignetteStart from '../../assets/images/Vignette-Slovenien-Start.svg';

const IntroSvnComponent = () => {
	const { lang } = useContext<IOfferContext>(OfferContext);
	useEffect(() => {
		sessionStorage.setItem('flowId', '7');
	}, []);
	return (
		<Walkthrough
			title="Sagen Sie „Zdravo“ von uns"
			text="Mit der E-Vignette für Autobahnen und Schnellstraßen bequem in Slowenien unterwegs. Für alle Motorräder, PKW und Transporter ≤ 3,5 Tonnen und sofort ab Kauf gültig."
			linkUrl={getUrlBasePath(`/${countryUrlMap[7]}/configure${setRouteLangParam(lang)}`)}
			slug={`${countryUrlMap[7]}`}
			image={VignetteStart}
			country="slowenien"
		/>
	);
};

export const IntroSvn = withLocalization(IntroSvnComponent);
